/* Play Ball Generator weight chart.
   Removes the static chart image and the "refer to the weight chart" sentence,
   then shows the live table directly above the description heading. */
(function () {
  var PLAY_WEIGHT_DATA_JSON = '{"soft":{"half-millet":{"62":75,"67":100,"70":100,"75":130,"78":135},"full-millet":{"62":105,"67":135,"70":150,"75":185,"78":230},"half-micro":{"62":75,"67":100,"70":100,"75":120,"78":130},"full-micro":{"62":100,"67":130,"70":140,"75":175,"78":185},"half-sand":{"62":80,"67":100,"70":110,"75":110,"78":120},"full-sand":{"62":160,"67":220,"70":240,"75":300,"78":370},"half-silicone":{"62":95,"67":100,"70":90,"75":100,"78":120},"full-silicone":{"62":110,"67":140,"70":160,"75":200,"78":230}},"elastic":{"half-millet":{"67":110,"75":150,"78":180},"full-millet":{"67":140,"75":190,"78":240},"half-micro":{"67":100,"75":130,"78":150},"full-micro":{"67":140,"75":170,"78":210},"half-sand":{"67":110,"75":150,"78":150},"full-sand":{"67":220,"75":290,"78":340},"half-silicone":{"67":110,"75":130,"78":150},"full-silicone":{"67":150,"75":200,"78":260}}}';
  var PLAY_WEIGHT_DATA = JSON.parse(PLAY_WEIGHT_DATA_JSON);

  var ROWS = [
    ["half-millet", "1/2 MILLET", "1/2 Millet"],
    ["full-millet", "FULL MILLET", "Millet"],
    ["half-micro", "1/2 MICRO SPHERES", "1/2 Micro Spheres"],
    ["full-micro", "FULL MICRO SPHERES", "Micro Spheres"],
    ["half-sand", "1/2 SAND", "1/2 Sand"],
    ["full-sand", "FULL SAND", "Sand"],
    ["half-silicone", "1/2 SILICONE OIL", "1/2 Silicone Oil"],
    ["full-silicone", "FULL SILICONE OIL", "Silicone Oil"],
  ];

  var SECTIONS = [
    ["soft", "SOFT SHELL", ["62", "67", "70", "75", "78"]],
    ["elastic", "ELASTIC SHELL", ["67", "75", "78"]],
  ];

  var SHELL_NAMES = {
    "soft-62": "62 mm Soft matte",
    "soft-67": "67 mm Soft matte",
    "soft-70": "70 mm Soft matte",
    "soft-75": "75 mm Soft matte",
    "soft-78": "78 mm Soft glossy",
    "elastic-67": "67 mm Elastic matte",
    "elastic-75": "75 mm Elastic matte",
    "elastic-78": "78 mm Elastic glossy",
  };

  function onGeneratorPage() {
    if (document.querySelector("[data-play-weight-chart]")) return true;
    return /ball-generator/.test(location.pathname);
  }

  function stripPrice(raw) {
    return String(raw || "")
      .replace(/\(\s*\+[^)]*\)/g, " ")
      .replace(/^[\s-]+/, "")
      .replace(/\s+/g, " ")
      .trim();
  }

  function parseShell(raw) {
    var text = stripPrice(raw).toLowerCase();
    var mmMatch = text.match(/(\d+)\s*mm/);
    if (!mmMatch) return null;
    var mm = mmMatch[1];
    if (!SHELL_NAMES["soft-" + mm] && !SHELL_NAMES["elastic-" + mm]) return null;
    var elastic = /elastic|elastisch/.test(text);
    var soft = /soft|morbid|weich/.test(text);
    var family = elastic ? "elastic" : soft ? "soft" : "";
    if (!family || !SHELL_NAMES[family + "-" + mm]) return null;
    return { family: family, mm: mm };
  }

  function parseFilling(raw) {
    var text = stripPrice(raw).toLowerCase();
    if (!text) return null;
    var half = /^1\s*\/\s*2\b|^½|half|mezzo|halb/.test(text);
    var material = "";
    if (/millet|miglio|hirse/.test(text)) material = "millet";
    else if (/micro|sphere|sfera|kugel|plastica/.test(text)) material = "micro";
    else if (/silicone|silikon|olio/.test(text)) material = "silicone";
    else if (/\bsand\b|sabbia/.test(text)) material = "sand";
    if (!material) return null;
    return (half ? "half" : "full") + "-" + material;
  }

  function weightFor(family, mm, filling) {
    var row = PLAY_WEIGHT_DATA[family] && PLAY_WEIGHT_DATA[family][filling];
    if (!row || typeof row[mm] !== "number") return null;
    return row[mm];
  }

  function labelHead(wrapper) {
    var label = wrapper.querySelector("label, .pplrlabel, .oindexlabel");
    if (!label) return "";
    var clone = label.cloneNode(true);
    var extra = clone.querySelector(".pplr_option_text_span");
    if (extra) extra.remove();
    return (clone.textContent || "").replace(/\s+/g, " ").trim().toUpperCase();
  }

  function wrapperFor(kind) {
    var wrappers = document.querySelectorAll(".pplr-wrapper");
    for (var i = 0; i < wrappers.length; i++) {
      var head = labelHead(wrappers[i]);
      if (kind === "shell" && /^(SHELL|SCOCCA|HULLE|HÜLLE|SCHALE)\b/.test(head)) {
        return wrappers[i];
      }
      if (kind === "filling" && /^(FILLING|RIEMPIMENTO|FULLUNG|FÜLLUNG|FUELLUNG)\b/.test(head)) {
        return wrappers[i];
      }
    }
    return null;
  }

  function groupValue(kind) {
    var wrapper = wrapperFor(kind);
    if (!wrapper) return "";
    var hidden = wrapper.querySelector('input[type="hidden"]');
    if (hidden && hidden.value.trim()) return hidden.value.trim();
    var selected = wrapper.querySelector(".selected[data-val], .pplr-swatch-element.selected");
    if (selected) {
      var fromData = selected.getAttribute("data-val");
      if (fromData) return fromData.trim();
      var pp = selected.querySelector(".ppdata");
      if (pp && pp.textContent.trim()) return pp.textContent.trim();
    }
    var span = wrapper.querySelector(".pplr_option_text_span");
    return span ? span.textContent.trim() : "";
  }

  function writeGroup(kind, value) {
    var wrapper = wrapperFor(kind);
    if (!wrapper) return;
    var hidden = wrapper.querySelector('input[type="hidden"]');
    var span = wrapper.querySelector(".pplr_option_text_span");
    if (hidden) hidden.value = value;
    if (span) span.textContent = value ? " - " + value : "";
    if (hidden) hidden.dispatchEvent(new Event("input", { bubbles: true }));
  }

  function cellButton(family, mm, filling, fillingName) {
    var grams = weightFor(family, mm, filling);
    if (grams == null) return '<td class="pwc-empty"></td>';
    var shellName = SHELL_NAMES[family + "-" + mm];
    return (
      '<td><button type="button" class="pwc-weight" data-pwc-cell data-family="' +
      family +
      '" data-mm="' +
      mm +
      '" data-filling="' +
      filling +
      '" data-shell-name="' +
      shellName +
      '" data-filling-name="' +
      fillingName +
      '">' +
      grams +
      " gr</button></td>"
    );
  }

  function buildTable() {
    var head =
      '<div class="pwc-readout"><p class="pwc-grams" data-pwc-grams>—</p><p class="pwc-detail" data-pwc-detail>Select a shell and a filling.</p></div>';
    var sections = SECTIONS.map(function (section) {
      var family = section[0];
      var title = section[1];
      var sizes = section[2];
      var sizeHeads = ["62", "67", "70", "75", "78"]
        .map(function (mm) {
          if (sizes.indexOf(mm) === -1) return '<th class="pwc-missing"></th>';
          return (
            '<th data-pwc-col data-family="' +
            family +
            '" data-mm="' +
            mm +
            '">' +
            mm +
            " mm</th>"
          );
        })
        .join("");
      var body = ROWS.map(function (row, index) {
        var cells = ["62", "67", "70", "75", "78"]
          .map(function (mm) {
            if (sizes.indexOf(mm) === -1) return '<td class="pwc-empty"></td>';
            return cellButton(family, mm, row[0], row[2]);
          })
          .join("");
        return (
          '<tr class="' +
          (index % 2 ? "pwc-alt" : "") +
          '"><th scope="row" data-pwc-row data-family="' +
          family +
          '" data-filling="' +
          row[0] +
          '">' +
          row[1] +
          "</th>" +
          cells +
          "</tr>"
        );
      }).join("");
      return (
        '<tbody><tr class="pwc-section"><th scope="colgroup">' +
        title +
        "</th>" +
        sizeHeads +
        "</tr>" +
        body +
        "</tbody>"
      );
    }).join("");

    return (
      head +
      '<div class="pwc-scroll"><table class="pwc-table"><caption>TABELLA DEI PESI — WEIGHT CHART — GEWICHTSKARTE</caption>' +
      sections +
      "</table></div>"
    );
  }

  function ensureStyle() {
    if (document.getElementById("play-weight-chart-style")) return;
    var style = document.createElement("style");
    style.id = "play-weight-chart-style";
    style.textContent =
      "#play-weight-chart{font-family:inherit;color:#1a1a1a;margin:8px 0 20px;max-width:100%}" +
      "#play-weight-chart .pwc-readout{display:flex;flex-wrap:wrap;align-items:baseline;gap:8px 16px;margin:0 0 12px}" +
      "#play-weight-chart .pwc-grams{margin:0;font-size:40px;line-height:1;font-weight:700;letter-spacing:-0.04em}" +
      "#play-weight-chart .pwc-detail{margin:0;font-size:15px;line-height:1.4}" +
      "#play-weight-chart .pwc-scroll{overflow-x:auto;border:1px solid #b5b5b5;background:#fff}" +
      "#play-weight-chart .pwc-table{border-collapse:collapse;width:100%;min-width:640px;font-size:13px;line-height:1.2}" +
      "#play-weight-chart caption{caption-side:top;text-align:left;font-weight:700;letter-spacing:0.04em;font-size:13px;padding:10px 12px;background:#f3f3f3;border-bottom:1px solid #b5b5b5}" +
      "#play-weight-chart th,#play-weight-chart td{border:1px solid #d0d0d0;padding:0;text-align:center;background:#fff}" +
      "#play-weight-chart th{font-weight:700}" +
      "#play-weight-chart .pwc-section th{background:#dedede;padding:8px 10px;text-align:left}" +
      "#play-weight-chart .pwc-section th[data-pwc-col],#play-weight-chart .pwc-missing{text-align:center;background:#dedede}" +
      "#play-weight-chart tbody th[scope='row']{text-align:left;padding:8px 10px;white-space:nowrap;position:sticky;left:0;background:#fff;z-index:1}" +
      "#play-weight-chart .pwc-alt th[scope='row'],#play-weight-chart .pwc-alt td{background:#f3f3f3}" +
      "#play-weight-chart .pwc-weight{appearance:none;border:0;background:transparent;width:100%;min-width:72px;padding:8px 6px;font:inherit;cursor:pointer;color:inherit}" +
      "#play-weight-chart .pwc-weight:hover{background:#fff4cc}" +
      "#play-weight-chart .pwc-weight:focus-visible{outline:2px solid #111;outline-offset:-2px}" +
      "#play-weight-chart .pwc-col{background:#fff4cc !important}" +
      "#play-weight-chart .pwc-row{background:#fff1b8 !important}" +
      "#play-weight-chart .pwc-hit{background:#161616 !important;color:#fff !important;font-weight:700}" +
      "#play-weight-chart .pwc-empty{background:#fafafa}";
    document.head.appendChild(style);
  }

  var CHART_IMAGE = 'img[src*="TABELLA-PESI"], img[src*="tabella-pesi"], img[src*="Foglio1"]';

  function plainText(node) {
    return (node.textContent || "").replace(/\u00a0/g, " ").replace(/\s+/g, " ").trim();
  }

  function findDescriptionHeading(scope) {
    var preview = scope.nodeType === 1 && scope.hasAttribute("data-play-weight-chart");
    var headings = scope.querySelectorAll(preview ? "h2" : "h2.majortitle");
    var labels = { DESCRIZIONE: 1, DESCRIPTION: 1, BESCHREIBUNG: 1 };
    for (var i = 0; i < headings.length; i++) {
      var upper = plainText(headings[i]).toUpperCase();
      if (labels[upper]) return headings[i];
    }
    var image = scope.querySelector(CHART_IMAGE);
    if (image) {
      var section = image.closest(".section-rich-text, .container, [data-play-weight-chart]");
      if (section) {
        var heading = section.querySelector("h2");
        if (heading) return heading;
      }
    }
    return null;
  }

  function isWeightIntro(text) {
    var upper = text.toUpperCase();
    if (!upper) return false;
    if (upper === "PESO" || upper === "WEIGHT" || upper === "GEWICHT") return true;
    if (upper.indexOf("SI PREGA DI FARE RIFERIMENTO") !== -1) return true;
    if (upper.indexOf("PLEASE REFER") !== -1) return true;
    if (upper.indexOf("GEWICHTSTABELLE") !== -1) return true;
    if (upper.indexOf("DIAGRAMMA") !== -1 && upper.indexOf("PESO") !== -1) return true;
    if (upper.indexOf("WEIGHT CHART") !== -1 && upper.indexOf("TOTAL WEIGHT") !== -1) return true;
    return false;
  }

  function stripWeightIntro(scope) {
    var paragraphs = scope.querySelectorAll("p");
    for (var i = 0; i < paragraphs.length; i++) {
      var paragraph = paragraphs[i];
      if (!paragraph.isConnected || paragraph.querySelector("#play-weight-chart")) continue;
      if (isWeightIntro(plainText(paragraph))) paragraph.remove();
    }
    var images = scope.querySelectorAll(CHART_IMAGE);
    for (var j = 0; j < images.length; j++) {
      var image = images[j];
      var parent = image.parentElement;
      image.remove();
      if (
        parent &&
        parent.tagName === "P" &&
        !plainText(parent) &&
        !parent.querySelector("img, iframe, video")
      ) {
        parent.remove();
      }
    }
  }

  function mount() {
    if (!onGeneratorPage()) return null;
    var existing = document.getElementById("play-weight-chart");
    if (existing) return existing;
    var preview = document.querySelector("[data-play-weight-chart]");
    var scope = preview || document;
    var heading = findDescriptionHeading(scope);
    var image = scope.querySelector(CHART_IMAGE);
    if (!heading && !image) return null;
    ensureStyle();
    var host = document.createElement("div");
    host.id = "play-weight-chart";
    host.innerHTML = buildTable();
    if (heading && heading.parentNode) heading.parentNode.insertBefore(host, heading);
    else image.replaceWith(host);
    stripWeightIntro(scope);
    host.addEventListener("click", function (event) {
      var button = event.target.closest("[data-pwc-cell]");
      if (!button || !host.contains(button)) return;
      writeGroup("shell", button.getAttribute("data-shell-name") || "");
      writeGroup("filling", button.getAttribute("data-filling-name") || "");
    });
    return host;
  }

  function scrollHitIntoView(host) {
    var hit = host.querySelector(".pwc-hit");
    var scroller = host.querySelector(".pwc-scroll");
    if (!hit || !scroller) return;
    var cell = hit.closest("td");
    if (!cell) return;
    var target = cell.offsetLeft - scroller.clientWidth / 2 + cell.offsetWidth / 2;
    scroller.scrollLeft = Math.max(0, target);
  }

  function apply() {
    var host = mount();
    if (!host) return;
    var shell = parseShell(groupValue("shell"));
    var filling = parseFilling(groupValue("filling"));
    var marked = host.querySelectorAll(".pwc-col, .pwc-row, .pwc-hit");
    for (var i = 0; i < marked.length; i++) {
      marked[i].classList.remove("pwc-col", "pwc-row", "pwc-hit");
    }
    if (shell) {
      var cols = host.querySelectorAll(
        '[data-family="' + shell.family + '"][data-mm="' + shell.mm + '"]',
      );
      for (var c = 0; c < cols.length; c++) cols[c].classList.add("pwc-col");
    }
    if (filling) {
      var families = shell ? [shell.family] : ["soft", "elastic"];
      families.forEach(function (family) {
        var rows = host.querySelectorAll(
          '[data-family="' + family + '"][data-filling="' + filling + '"]',
        );
        for (var r = 0; r < rows.length; r++) rows[r].classList.add("pwc-row");
      });
    }
    var grams = shell && filling ? weightFor(shell.family, shell.mm, filling) : null;
    if (grams != null) {
      var hit = host.querySelector(
        '[data-pwc-cell][data-family="' +
          shell.family +
          '"][data-mm="' +
          shell.mm +
          '"][data-filling="' +
          filling +
          '"]',
      );
      if (hit) {
        hit.classList.remove("pwc-col", "pwc-row");
        hit.classList.add("pwc-hit");
        scrollHitIntoView(host);
      }
    }
    var gramsEl = host.querySelector("[data-pwc-grams]");
    var detailEl = host.querySelector("[data-pwc-detail]");
    var shellName = stripPrice(groupValue("shell"));
    var fillingName = stripPrice(groupValue("filling"));
    if (grams != null) {
      gramsEl.textContent = grams + " gr";
      detailEl.textContent = shellName + ", " + fillingName + ".";
    } else if (shell && filling) {
      gramsEl.textContent = "—";
      detailEl.textContent = "This shell is not made with that filling.";
    } else if (shell) {
      gramsEl.textContent = "—";
      detailEl.textContent = shellName + ". Select a filling to see the weight.";
    } else if (filling) {
      gramsEl.textContent = "—";
      detailEl.textContent = fillingName + ". Select a shell to see the weight.";
    } else {
      gramsEl.textContent = "—";
      detailEl.textContent = "Select a shell and a filling.";
    }
  }

  var scheduled = false;
  var lastKey = null;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    setTimeout(function () {
      scheduled = false;
      if (onGeneratorPage()) apply();
    }, 30);
  }

  var applySelection = apply;
  apply = function () {
    var shellRaw = groupValue("shell");
    var fillingRaw = groupValue("filling");
    var key = shellRaw + "\n" + fillingRaw + "\n" + (document.getElementById("play-weight-chart") ? "1" : "0");
    if (key === lastKey) return;
    lastKey = key;
    applySelection();
  };

  function start() {
    if (!onGeneratorPage()) return;
    applySelection();
    lastKey = groupValue("shell") + "\n" + groupValue("filling") + "\n1";
    document.addEventListener("input", schedule, true);
    document.addEventListener("change", schedule, true);
    document.addEventListener("click", schedule, true);
    var observer = new MutationObserver(function () {
      if (!document.getElementById("play-weight-chart")) schedule();
      else {
        var preview = document.querySelector("[data-play-weight-chart]");
        stripWeightIntro(preview || document);
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      lastKey = null;
      apply();
      if (document.getElementById("play-weight-chart") || tries > 40) clearInterval(timer);
    }, 500);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
